import React from 'react';
import { getPortalDOMId } from './common';
import classNames from 'classnames';
export const PortalHost = ({ name, className, children }) => {
    return (React.createElement("div", { className: classNames('portal', className), id: getPortalDOMId(name) }, children));
};
